const config = {
	api: 'https://demo.beautitag.com/path/api',
	asset: 'https://demo.beautitag.com/path/asset',
	loginTimeout: 18000000
};

export default config;
